import { render, staticRenderFns } from "./EditorImageUploadButton.vue?vue&type=template&id=468caed2"
import script from "./EditorImageUploadButton.vue?vue&type=script&lang=js"
export * from "./EditorImageUploadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports